import { ENDPOINTS } from 'config/endpoints';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import { invalidateActivitiesQueries } from '../event/useActivitiesSearch';
import { invalidateTimelineQueries } from '../timeline/useSearchTimeline';

export type MeetingProvider = 'Google' | 'Outlook';

export interface DeleteMeetingPayload {
  meetingId: number;
  provider: MeetingProvider;
}

const deleteMeeting = (payload: DeleteMeetingPayload) => {
  const request: Request = {
    url: ENDPOINTS.calendar.meeting,
    config: { method: 'DELETE', data: payload },
  };
  return client(request);
};

export default function useDeleteMeeting() {
  const queryClient = useQueryClient();
  return useMutation<Response<null>, CronoError, DeleteMeetingPayload>(
    deleteMeeting,
    {
      meta: {
        successMessage: 'Meeting deleted',
        errorMessage: 'Failed to delete meeting',
      },
      onSuccess: () => {
        invalidateActivitiesQueries(queryClient);
        invalidateTimelineQueries(queryClient);
      },
    },
  );
}
